document.addEventListener("DOMContentLoaded", function () {
  const cookieBanner = document.getElementById("cookie-banner");
  const acceptButton = document.getElementById("accept-cookies");
  const denyButton = document.getElementById("deny-cookies");

  function pingConsent(eventName) {
    const url = "/wp-json/tei-consent/v1/ping";

    // Prefer Beacon (survives reload/navigation)
    if (navigator.sendBeacon) {
      // send as JSON; WP REST will parse it
      const blob = new Blob([JSON.stringify({ event: eventName })], {
        type: "application/json",
      });
      navigator.sendBeacon(url, blob);
      return;
    }

    // Fallback for old browsers
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event: eventName }),
      keepalive: true,
    });
  }

  // Accept
  acceptButton.addEventListener("click", function () {
    pingConsent("accept"); // <- beacon
    localStorage.setItem("cookie_consent", "yes");
    cookieBanner.style.display = "none";
    // tiny delay is harmless, but beacon already handles it
    setTimeout(() => location.reload(), 50);
  });

  // Decline
  denyButton.addEventListener("click", function () {
    pingConsent("decline"); // no reload, but beacon makes it robust anyway
    localStorage.setItem("cookie_consent", "no");
    cookieBanner.style.display = "none";
  });

  // Show banner if no cookie consent preference is set
  if (!localStorage.getItem("cookie_consent")) {
    cookieBanner.style.display = "block";
  }
});
